/**
 * FcmSubscribePrompt — shown when browser notification permission is in 'default' state.
 *
 * Purpose: prompt user to opt-in to push notifications.
 * Flow: renders nothing if permission is already granted or denied.
 * When the user clicks "Enable", calls requestPermission() from useFcmToken.
 */
import { useFcmToken } from "../hooks/useFcmToken";
import { BellIcon } from "lucide-react";

export function FcmSubscribePrompt() {
  const { permission, requestPermission, loading } = useFcmToken();

  if (permission !== "default") {
    return null;
  }

  return (
    <div className="flex items-center gap-3 p-4 glass rounded-xl">
      <BellIcon className="w-5 h-5 text-muted-foreground shrink-0" />
      <p className="text-sm flex-1 text-start">
        Enable notifications to receive real-time alerts.
      </p>
      <button
        onClick={requestPermission}
        disabled={loading}
        className="btn btn-sm btn-primary"
      >
        {loading ? "Enabling..." : "Enable"}
      </button>
    </div>
  );
}